export function mapCollectionListItem(item) {
  const { id, image: imageUrl, name, package_ids: packageIds } = item;

  return {
    id: id.toString(),
    imageUrl,
    name,
    packageCount: (packageIds || []).length,
    route: { name: "CollectionDetailPage", params: { id } },
  };
}
